import sample_1 from './schweisser.jpg';

export const schweisserImpressions = {
    sample_1,
};
